import { useLocation } from 'react-router-dom';

export function useShopInfo() {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const idToken = urlParams.get('id_token');
  const shop = urlParams.get('shop');

  const shopId = shop?.split('.')[0] || null;

  return {
    idToken,
    shopId,
    shop,
  };
}
